import { render, staticRenderFns } from "./TableApps.vue?vue&type=template&id=11baf510&"
import script from "./TableApps.vue?vue&type=script&lang=js&"
export * from "./TableApps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports